import { menuItems, menuTags } from "@/plugins/firebase";
const state = {
  menus: [
    {
      name: "Coffee and Drinks",
      slug: "drinks",
      categories: [
        { uid: "Hot & Iced coffee", id: "hot-iced-coffee", items: [] },
        { uid: "Smoothies", id: "smothies", items: [] },
        { uid: "Frappe", id: "frappe", items: [] },
        { uid: "Tea & Tisanas", id: "tea", items: [] },
        { uid: "Juices", id: "juices", items: [] },
        { uid: "Fresh Drinks", id: "fresh-drinks", items: [] },
        { uid: "Soda", id: "soda", items: [] },
      ],
    },
    {
      name: "All Day Brunch",
      slug: "all-day-brunch",
      categories: [
        {
          uid: "Bowls",
          id: "bowls",
          items: [],
        },
        { uid: "Toasts", id: "toasts", items: [] },
        { uid: "Chilaquiles & eggs", id: "chilaquiles-eggs", items: [] },
        { uid: "Croissant Breakfast", id: "croissant-breakfast", items: [] },
        { uid: "Keto Friendly", id: "keto-friendly", items: [] },
        { uid: "Pancakes & Wafffles", id: "pancakes-waffles", items: [] },
      ],
    },
    {
      name: "Appetizers",
      slug: "appetizers",
      categories: [
        { uid: "Appetizers", display: false, id: "appetizers", items: [] },
      ],
    },
    {
      name: "Lunch & Dinner",
      slug: "lunch-dinner",
      categories: [
        { uid: "Soups", id: "soups-pasta", items: [] },
        { uid: "Salads & Ceviche", id: "salads-ceviche", items: [] },
        { uid: "Sandwiches & Paninis", id: "sandwiches-paninis", items: [] },
        { uid: "Everyday Specials", id: "everyday-specials", items: [] },
        { uid: "Pizza & pasta", id: "Pizza & Pasta", items: [] },
      ],
    },
    {
      name: "Healthy Snacks",
      slug: "healthy-snacks",
      categories: [
        {
          uid: "Healthy Snacks",
          display: false,
          id: "healthy-snacks",
          items: [],
        },
      ],
    },
    {
      name: "Bakery, Desserts & Ice Cream",
      slug: "bakery-desserts-ice-cream",
      categories: [
        { uid: "Bakery", id: "bakery", items: [] },
        { uid: "Desserts", id: "desserts", items: [] },
        { uid: "Ice Cream", id: "ice-cream", items: [] },
      ],
    },
    /*   {
      name: "Kids Menu",
      slug: "kids-menu",
      categories: [
        { uid: "Kids Menu", display: false, id: "kids-menu", items: [] },
      ],
    }, */
    {
      name: "Wine & Cocktails",
      slug: "wine-cocktails",
      categories: [
        { uid: "Wine", id: "wine", items: [] },
        { uid: "Cocktails", id: "cocktails", items: [] },
        { uid: "Beer", id: "beer", items: [] },
        { uid: "Liquors", id: "liquors", items: [] },
      ],
    },
  ],
  allMenuItems: [],
  menuTags: [],
};

const getters = {
  allCategories(state) {
    let categoriesArray = [];
    for (var i = 0; i < state.menus.length; i++) {
      for (var j = 0; j < state.menus[i].categories.length; j++) {
        categoriesArray.push({
          uid: state.menus[i].categories[j].uid,
          id: state.menus[i].categories[j].id,
          menu: state.menus[i].slug,
          name: state.menus[i].name,
        });
      }
    }
    return categoriesArray;
  },
};

const mutations = {
  pushMenuItem(state, payload) {
    let menu = payload.category;
    let type = payload.type;
    const menuIndex = state.menus.findIndex((item) => item.slug === menu);
    const categoryIndex = state.menus[menuIndex].categories.findIndex(
      (item) => (item.id = type)
    );
    state.menus[menuIndex].categories[categoryIndex].items.push(payload);
  },
  setMenu(state, payload) {
    let menu = -1;
    let type = -1;
    let menuIndex = null;
    let categoryIndex = null;
    let menuItem;
    let sortedMenu = [];
    for (let item of payload.docs) {
      menuItem = item.data();
      if (menuItem.order != null) {
        menuItem.order = parseInt(menuItem.order);
      } else {
        menuItem.order = 0;
      }
      sortedMenu.push(menuItem);
    }
    console.log(sortedMenu);
    sortedMenu = sortedMenu.sort((a, b) => a.order - b.order);
    console.log(sortedMenu);

    for (let item of sortedMenu) {
      menuItem = item;
      menu = menuItem.category;
      type = menuItem.type;
      menuIndex = state.menus.findIndex((cat) => cat.slug === menu);

      if (menuIndex >= 0) {
        categoryIndex = state.menus[menuIndex].categories.findIndex((sub) => {
          return sub.id === type;
        });
        if (categoryIndex >= 0) {
          state.menus[menuIndex].categories[categoryIndex].items.push(menuItem);
        }
      }
    }
  },
  setTags(state, payload) {
    for (let tag of payload.docs) {
      state.menuTags.push(tag.data());
    }
  },
};

const actions = {
  async addMenuItem({ commit }, data) {
    const resp = await menuItems.add(data);
    commit("pushMenuItem", data);
    if (resp) {
      return true;
    } else return false;
  },
  async fetchMenuItems({ commit }, data) {
    const menu = data;
    const menuIndex = state.menus.findIndex((cat) => cat.slug === menu);
    if (state.menus[menuIndex].categories[0].items.length == 0) {
      console.log("Pidiendo datos");
      const resp = await menuItems.where("category", "==", data).get();
      commit("setMenu", resp);
    }
  },
  async fetchTags({ commit }) {
    if (state.menuTags.length < 1) {
      const resp = await menuTags.get();
      commit("setTags", resp);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
